export default __webpack_public_path__ + "static/media/smaram-logo.50ff3a88.svg";